<template>
	<div ref="charts"></div>
</template>

<script>
	import {getStore, mapStore} from './store.js'
	import * as echarts from 'echarts'
	
	export default {
		data() {
			return {
				...getStore(this, 'digitalStore')
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/star_distribution',
					success: data => {
						this.echartsObj.clear();
						this.echartsObj.setOption({
							color: ['#FF5555', '#FFDC1A', '#02F4FF', '#19AEF1', '#07F3A4'],
							tooltip: {
								trigger: 'item'
							},
							legend: {
								bottom: '0',
								left: 'center',
								itemWidth: this.px(14),
								itemHeight: this.px(4),
								textStyle: {
									fontSize: this.px(12),
									color: '#ABFFE9'
								}
							},
							series: {
								type: 'pie',
								center: window.innerHeight < 750 ? ['50%', '42%'] : ['50%', '45%'],
								radius: window.innerHeight < 750 ? ['15%', '45%'] : ['25%', '55%'],
								label: {
									formatter: '{d}% ({b})',
									fontSize: this.px(13),
									color: '#ABFFE9'
								},
								data: data.star_distribution.map(item => {
									return {
										name: item.label,
										value: item.count
									}
								})
							}
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>